import {
  ChatInput,
  type ChatInputProps,
} from '@stripe-internal/conversations-ui';

import {InputDotCom} from './InputDotCom';

export function DotComChatInput(props: ChatInputProps) {
  return (
    <ChatInput
      {...props}
      InputComponent={InputDotCom}
      newDesignEnabled={false}
    />
  );
}
